module.exports = __webpack_public_path__ + "static/media/icono_mail.eee1b655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_mail.png
// module id = 881
// module chunks = 0